module.exports = __webpack_public_path__ + "img/1.Job_Search_menu-long.3b4f3682.png";